import { useState } from 'react';
import useSWR from 'swr';
import { Alert, Button, Stack } from '@mui/material';
import { api } from '../../lib/api';
import { useAuthStore } from '../../store/authStore';

export function EmailConsentPrompt({ onPreferences }: { onPreferences: () => void }) {
  const { user, sessionKind, supportSession } = useAuthStore();
  const [dismissed, setDismissed] = useState(false);
  const { data } = useSWR(
    user && sessionKind !== 'kiosk' && !supportSession ? ['email-consent-choice', user.id] : null,
    async () => (await api.get('/email-preferences')).data.data,
    { revalidateOnFocus: false },
  );
  if (dismissed || !data || data.hasChoice) return null;
  return (
    <Alert
      role="status"
      severity="info"
      sx={{ mb: 2 }}
      action={
        <Stack direction="row" spacing={1}>
          <Button
            color="inherit"
            onClick={() => {
              setDismissed(true);
              onPreferences();
            }}
          >
            Choose emails
          </Button>
          <Button color="inherit" onClick={() => setDismissed(true)}>
            Not now
          </Button>
        </Stack>
      }
    >
      Paddiq may email you product news and tips. You can opt out in email preferences or use the
      unsubscribe link in any marketing email.
    </Alert>
  );
}
